/*
 * @Author: Teemo Ding
 * @Date: 2021-04-15 14:49:44
 * @LastEditTime: 2021-10-09 15:24:13
 * @LastEditors: Teemo Ding
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/Carousel/index.tsx
 */

import React from 'react';
import { useDispatch } from 'react-redux';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import CarouselComponent from '../../Components/CarouselWithChebox';
// import { EnumLinkType } from '@/src/types/common/linkType';
// import { randomNumber } from 'src/tools/helper';

import {
  EnumCollapseId,
  getCarousel,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  onCollapseOpen,
  onDynamicDataAdd,
  onDynamicDataChange,
  onDynamicDataDelete,
  onDynamicDataSort,
  onErrorChange,
  onStaticChange,
} from '../slice';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { contentCarouselGenerator } from 'src/pages/SalesChannelProductsConfig';
import { validateCarousel } from '../tools';

const Carousel = (props) => {
  const { data, specificError = {}, isOnPrimaryLanguage, disabled } = props;
  const _d = useDispatch();

  const handleOnStaticChange = (draggableId, data) => {
    _d(onStaticChange({ draggableId, data }));
  };

  const handleOnAdd = (draggableId) => {
    _d(onDynamicDataAdd(contentCarouselGenerator(draggableId)));
  };

  const handleItemChange = (draggableId, index, data) => {
    _d(
      onDynamicDataChange({
        draggableId,
        index,
        data,
      }),
    );
  };

  const handleItemSort = (draggableId, from, to) => {
    _d(
      onDynamicDataSort({
        draggableId,
        from,
        to,
      }),
    );
  };

  const handleItemDelete = (draggableId, index) => {
    _d(
      onDynamicDataDelete({
        draggableId,
        index,
      }),
    );
  };

  return (
    <div>
      <CarouselComponent
        draggableId='carousel'
        onItemDelete={handleItemDelete}
        onItemAdd={handleOnAdd}
        onItemChange={handleItemChange}
        onItemSort={handleItemSort}
        onStaticChange={handleOnStaticChange}
        data={data}
        hideAutoPlay={!isOnPrimaryLanguage}
        specificError={specificError}
        disabled={disabled}
      />
    </div>
  );
};

export default ErrorProcessingHOC(Carousel, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.carousel,
  getContent: getCarousel,
  title: getI18nFromGeneral('general.hOCTitle.carousel'),
  validation: validateCarousel,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
